import { Outlet } from 'react-router-dom'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Helmet } from 'react-helmet-async'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/ru'
import isoCountries from 'i18n-iso-countries'
import isoCountriesRuLocale from 'i18n-iso-countries/langs/ru.json'
import styles from './App.module.scss'
import InterLight from 'assets/fonts/Inter/Inter-Light.woff2'
import InterMedium from 'assets/fonts/Inter/Inter-Medium.woff2'
import InterSemiBold from 'assets/fonts/Inter/Inter-SemiBold.woff2'
import AppBackground from 'components/AppBackground'
import Header from 'components/Header'
import Navigation from 'components/Navigation'
import Copyright from 'components/Copyright'

dayjs.locale('ru')
dayjs.extend(relativeTime)

isoCountries.registerLocale(isoCountriesRuLocale)

const queryClient = new QueryClient()

export default function App () {
  return (
    <QueryClientProvider client={ queryClient }>
      <div className={ styles.container }>
        <Helmet>
          <link
            rel="prefetch"
            as="font"
            type="font/woff2"
            href={ InterLight }
            crossorigin />

          <link
            rel="prefetch"
            as="font"
            type="font/woff2"
            href={ InterMedium }
            crossorigin />

          <link
            rel="prefetch"
            as="font"
            type="font/woff2"
            href={ InterSemiBold }
            crossorigin />
        </Helmet>

        <AppBackground
          src="images/background@1920w.png"
          mobileSrc="images/background-mobile@2x.png"
          srcSet="
            images/min/background@2x-min.png 2x,
            images/background@1280w.png 1280w,
            images/background@1366w.png 1366w,
            images/background@1440w.png 1440w,
            images/background@1536w.png 1536w,
            images/background@1600w.png 1600w,
            images/background@1920w.png 1920w"
          mobileSrcSet="
            images/background-mobile@1x.png 1x,
            images/background-mobile@1.5x.png 1.5x,
            images/background-mobile@2x.png 2x,
            images/background-mobile@2.5x.png 2.5x,
            images/min/background-mobile@3x-min.png 3x,
            images/min/background-mobile@3.5x-min.png 3.5x,
            images/min/background-mobile@4x-min.png 4x"/>

        <Header variant="popup">
          <Navigation />
        </Header>

        <main>
          <Outlet />
        </main>

        <footer>
          <Copyright author='/fa/ sales' fromYear='2018' />
        </footer>
      </div>

      {
        process.env.NODE_ENV === 'development' && <ReactQueryDevtools />
      }
    </QueryClientProvider>
  )
}
